<template>
  <div :class="defineSize">
    {{formatName}}
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "UserInfoLogo",
  props:{
    isNavabar: {
      type: Boolean,
      default: true
    }
  },
  computed:{
    defineSize(){
      const size = this.isNavabar ? 'userInfoDefault' : 'userInfo'
      return `d-flex align-items-center justify-content-center ${size}`
    },
    formatName(){
      const name = store.getters["user/getName"];
      if (name) {
        const first = name.substr(0,1);
        const last = name.substr(-1,1);
        return (first + last).toUpperCase();
      }
    }
  }
}
</script>

<style scoped>
  .userInfoDefault {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(90deg, #2A66C1 0%, #24CFEF 100%);
    color: white;
    font-size: 15px;
  }

  .userInfo {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(90deg, #2A66C1 0%, #24CFEF 100%);
    color: white;
    font-size: 20px;
  }
</style>